<template>
  <AuthLoginElement>
    <slot />
  </AuthLoginElement>
</template>

<script lang="ts" setup>
import { onMounted } from 'vue'

// Check for dark mode preference on mount
onMounted(() => {
  // Check localStorage first, then fallback to user preference
  const storedTheme = localStorage.getItem('theme')

  if (storedTheme === 'dark') {
    document.documentElement.classList.add('dark')
  }
  else if (storedTheme === 'light') {
    document.documentElement.classList.remove('dark')
  }
  else {
    // If no stored preference, check user system preference
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
    if (prefersDark) {
      document.documentElement.classList.add('dark')
      localStorage.setItem('theme', 'dark')
    }
    else {
      document.documentElement.classList.remove('dark')
      localStorage.setItem('theme', 'light')
    }
  }
})
</script>
